// extracted by mini-css-extract-plugin
export default {"tabpanel":"TabPanel_tabpanel__9ocf2"};